// Keyboard focus containment for the "On this map" tray: Tab and Shift+Tab cycle within it.

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export function focusableWithin(root: HTMLElement | null | undefined): HTMLElement[] {
  if (!root) return [];
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE));
}

/**
 * Where Tab should go instead of the browser's default, or null to let the browser move
 * focus. Wraps from the last element to the first (and back with Shift), and pulls focus
 * back in if it has somehow left the trap.
 */
export function wrapFocus(
  focusable: readonly HTMLElement[],
  active: Element | null,
  backwards: boolean,
): HTMLElement | null {
  if (focusable.length === 0) return null;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const index = active ? focusable.indexOf(active as HTMLElement) : -1;
  if (index === -1) return backwards ? last : first;
  if (backwards && index === 0) return last;
  if (!backwards && index === focusable.length - 1) return first;
  return null;
}
